/* eslint-disable no-console */
import { Subject } from 'rxjs'

let events = new Subject()
let subscription = null

export class Debugger {
    static enabled() {
        return subscription !== null
    }

    static start() {
        subscription = events.subscribe(play => play())
    }

    static stop() {
        if (this.enabled()) {
            subscription.unsubscribe()
        }
    }
}

export function log(...args) {
    events.next(() => console.log(...args))
}

export function info(...args) {
    events.next(() => console.info(...args))
}

export function warn(...args) {
    events.next(() => console.warn(...args))
}
